import {Platform} from './global';

export class BrowserPlatform extends Platform {

}
